import React, {useEffect, useState} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Like from "../actions/Like";

export default function CommentActions(props) {
    let {
        comment,
        currentUser={},
        showReplies=true,
        showLikes=true,
        hoverBg='white',
        token,
        replyCount,
        toggleRegistration=()=>{},
        leadData={}
    } = props;

    const [showReplyForm, setShowReplyForm] = useState(false);
    // Also in props: onToggleReplyForm

    const userSignedIn = !!currentUser;
    const viewingSelf = userSignedIn && currentUser.id == comment.author.id;
    const adminUser = userSignedIn && currentUser.admin;


    useEffect(() => {
        if (userSignedIn) {
            props.onToggleReplyForm(showReplyForm);
        }
    }, [showReplyForm]);

    // render functions

    const renderReplyLink = () => {
        if(showReplies && replyCount == 0) {
            return (
                <Col xs={6} sm={'auto'} className={'py-2 ms-sm-auto px-0 px-sm-2'}>
                    <a
                        aria-expanded={showReplyForm}
                        aria-controls={'toggleReplyForm'}
                        data-after-signin-redirect={comment.actions.posting_url}
                        data-external-only={1}
                        className={`p-2 link-secondary font-14 hover-bg-${hoverBg} ${!userSignedIn && 'gitb-modal-register-open' }`}
                        onClick={() => userSignedIn ? setShowReplyForm(!showReplyForm) : toggleRegistration() }>
                        <i className={'fal me-2 fa-reply'}></i>
                        <span className={'fw-bold'}>Reply</span>
                    </a>
                </Col>
            )
        }
    }

    const renderLikeLink = () => {
        if(showLikes && !viewingSelf) {
            return (
                <Col xs={6} sm={'auto'}  className={'py-2 ps-0'}>
                    <Like item={comment}
                          itemLikeUrl={comment.actions.like}
                          itemUrl={comment.actions.posting_url}
                          userSignedIn={userSignedIn}
                          currentUser={currentUser}
                          token={token}
                          hoverBg={hoverBg}
                          toggleRegistration={toggleRegistration}
                    />
                </Col>
            )
        }
    }

    return (
        <Row className={'row align-items-center mx-0'}>
            {renderLikeLink()}
            {renderReplyLink()}
        </Row>
    )
}